var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_2240_10479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7755 93.9829L79.5544 95.577C78.2135 95.6944 77.0315 94.7024 76.9143 93.3618L69.5036 8.6567C69.3862 7.31588 70.3782 6.13384 71.7188 6.01666L89.9399 4.42252C91.2807 4.30513 92.4628 5.29713 92.5799 6.63775L99.9907 91.3428C100.108 92.6835 99.1163 93.8655 97.7755 93.9829Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9404 4.42249L82.9766 5.03167C84.3174 4.91429 85.4994 5.90628 85.6166 7.2469L93.0273 91.9518C93.1447 93.2926 92.1527 94.4746 90.8121 94.5918L97.776 93.9826C99.1168 93.8653 100.109 92.6832 99.9912 91.3426L92.5805 6.63792C92.4631 5.2971 91.2812 4.3053 89.9404 4.42249Z",
    fill: "#0055A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4434 76.8491L98.5154 74.8338L99.3143 83.9807L76.2423 85.996L75.4434 76.8491Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.642 67.1878L77.1436 15.7698C77.0947 15.2112 77.508 14.7187 78.0666 14.6698L85.1922 14.0464C85.7508 13.9976 86.2434 14.4109 86.2922 14.9694L90.7906 66.3874C90.8395 66.946 90.4262 67.4386 89.8676 67.4874L82.742 68.1108C82.1834 68.1597 81.6908 67.7464 81.642 67.1878Z",
    fill: "#C0D6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5527 75.4419L98.5154 74.8337L99.3144 83.9806L92.3517 84.5888L91.5527 75.4419Z",
    fill: "#0473CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0566 94.9512H48.766C47.4201 94.9512 46.3291 93.8601 46.3291 92.5143V7.48574C46.3291 6.13984 47.4201 5.04883 48.766 5.04883H67.0566C68.4025 5.04883 69.4936 6.13984 69.4936 7.48574V92.5143C69.4936 93.8601 68.4025 94.9512 67.0566 94.9512Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3291 75.9414H69.4937V85.125H46.3291V75.9414Z",
    fill: "#F47C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3193 66.852V15.2376C53.3193 14.6769 53.774 14.2222 54.3348 14.2222H61.4877C62.0484 14.2222 62.5031 14.6769 62.5031 15.2376V66.852C62.5031 67.4128 62.0484 67.8675 61.4877 67.8675H54.3348C53.774 67.8675 53.3193 67.413 53.3193 66.852Z",
    fill: "#F9C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.057 5.04883H60.0664C61.4123 5.04883 62.5033 6.14004 62.5033 7.48574V92.5143C62.5033 93.8601 61.4123 94.9512 60.0664 94.9512H67.0568C68.4027 94.9512 69.4938 93.86 69.4938 92.5143V7.48574C69.4939 6.13984 68.4029 5.04883 67.057 5.04883Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5029 75.9414H69.4934V85.125H62.5029V75.9414Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8928 94.9512H25.602C24.2561 94.9512 23.165 93.8601 23.165 92.5143V7.48574C23.165 6.13984 24.2561 5.04883 25.602 5.04883H43.8926C45.2385 5.04883 46.3295 6.13984 46.3295 7.48574V92.5143C46.3297 93.8601 45.2387 94.9512 43.8928 94.9512Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.165 75.9414H46.3297V85.125H23.165V75.9414Z",
    fill: "#57BE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1553 66.852V15.2376C30.1553 14.6769 30.61 14.2222 31.1707 14.2222H38.3236C38.8844 14.2222 39.3391 14.6769 39.3391 15.2376V66.852C39.3391 67.4128 38.8844 67.8675 38.3236 67.8675H31.1707C30.61 67.8675 30.1553 67.413 30.1553 66.852Z",
    fill: "#AEDEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8928 5.04883H36.9023C38.2482 5.04883 39.3393 6.14004 39.3393 7.48574V92.5143C39.3393 93.8601 38.2482 94.9512 36.9023 94.9512H43.8928C45.2387 94.9512 46.3297 93.86 46.3297 92.5143V7.48574C46.3297 6.13984 45.2387 5.04883 43.8928 5.04883Z",
    fill: "#02905D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3389 75.9414H46.3293V85.125H39.3389V75.9414Z",
    fill: "#22B27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7277 94.9512H2.43691C1.09102 94.9512 0 93.8601 0 92.5143V7.48574C0 6.13984 1.09102 5.04883 2.43691 5.04883H20.7275C22.0734 5.04883 23.1645 6.13984 23.1645 7.48574V92.5143C23.1646 93.8601 22.0736 94.9512 20.7277 94.9512Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75.9414H23.1646V85.125H0V75.9414Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99023 66.852V15.2376C6.99023 14.6769 7.44492 14.2222 8.00566 14.2222H15.1586C15.7193 14.2222 16.174 14.6769 16.174 15.2376V66.852C16.174 67.4128 15.7193 67.8675 15.1586 67.8675H8.00566C7.44492 67.8675 6.99023 67.413 6.99023 66.852Z",
    fill: "#C0D6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7279 5.04883H13.7373C15.0832 5.04883 16.1742 6.14004 16.1742 7.48574V92.5143C16.1742 93.8601 15.0832 94.9512 13.7373 94.9512H20.7277C22.0736 94.9512 23.1646 93.86 23.1646 92.5143V7.48574C23.1648 6.13984 22.0738 5.04883 20.7279 5.04883Z",
    fill: "#0055A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1738 75.9414H23.1643V85.125H16.1738V75.9414Z",
    fill: "#0473CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2240_10479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.d1a2b894694e133e2e4cc2b24365941d.svg";
export { ForwardRef as ReactComponent };